import React, { useEffect, useState } from 'react';
import { Field, FileInput } from '@smartplatform/ui';

export const Thumbnail = ({ record, label, field = 'thumbnail' }) => {
	const [thumbnail, setThumbnail] = useState();

	useEffect(() => {
		const img = record[field] ? record.downloadFile(field) : null;
		// console.log('thumbnail img ', img);
		setThumbnail(img);
	}, []);

	const onChange = image => {
		image && setThumbnail(image.preview);
		console.log(thumbnail, image);
	};

	const onDelete = record => {
		console.log(record);
		setThumbnail(false);
	};

	// console.log('rendering', thumbnail);
	return (
		<>
			<Field property={field}>
				<label>{label}</label>
				<FileInput onChange={onChange} onDelete={onDelete} accept={'image/jpeg, image/png'} />
			</Field>

			{thumbnail && (
				<div className="form__thumbnail">
					<img alt="img" style={{ width: '250px' }} src={thumbnail} />
				</div>
			)}
		</>
	);
};
